export default {
  path: '/quality_layers',
  name: 'quality_layers',
  component: () => import('../components/qualitylayer/Layout'),
  redirect: { name: 'QualityLayerList' },
  meta: {
    breadcrumb: 'profile.quality.layers',
  },
  children: [
    {
      name: 'QualityLayerList',
      path: '',
      component: () => import('../views/qualitylayer/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'QualityLayerCreate',
      path: 'new',
      component: () => import('../views/qualitylayer/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'QualityLayerUpdate',
      path: ':id/edit',
      component: () => import('../views/qualitylayer/Update'),
      meta: {
        breadcrumb: 'profile.quality.layer',
      },
    },
    {
      name: 'QualityLayerShow',
      path: ':id',
      component: () => import('../views/qualitylayer/Show'),
      meta: {
        breadcrumb: 'profile.quality.layer',
      },
    }
  ]
};
